import RecordVideoSuccess from './src/main';

/* istanbul ignore next */
RecordVideoSuccess.install = function (Vue) {
  Vue.component(RecordVideoSuccess.name, RecordVideoSuccess);
};

export default RecordVideoSuccess;
